import { isValidNumber } from "./isValidCoordinates";

export const safeCoordTuple = (lat: any, lng: any): [number, number] | null => {
  if (lat == null || lng == null) return null;
  if (!isValidNumber(lat) || !isValidNumber(lng)) return null;
  const latNum = Number(lat);
  const lngNum = Number(lng);
  if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return null;
  if (latNum < -90 || latNum > 90 || lngNum < -180 || lngNum > 180) return null;
  return [latNum, lngNum];
};
